import ErrorComponent from "@/components/atoms/ErrorComponent";
import RecordCallLogsCard from "@/components/molecules/cards/callLogs/RecordCallLogsCard";
import PersonHeader from "@/components/molecules/card-headers/people/PersonHeader";
import PersonDetailsCard from "@/components/molecules/cards/person/PersonDetailsCard";
import PersonNotesCard from "@/components/molecules/cards/person/PersonNotesCard";
import { UUID_REGEX } from "@/constants/regexs";
import { pluralize } from "@/helpers/utils";
import Person from "@/interfaces/Person";
import {
  faComment,
  faPhone,
  faUser,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SimpleBar from "simplebar-react";

const PersonView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [person, setPerson] = useState<Person>();
  const [totals, setTotals] = useState({
    courses: 0,
    notes: 0,
    calls: 0,
  });

  const onGetTotal = (key: string, total: number) => {
    setTotals((prev) => ({ ...prev, [key]: total }));
  };

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page">
      {person && <PersonHeader id={id} companyId={person.companyId} />}
      <Row className="g-3">
        <Col xxl={4} xl={5}>
          <PersonDetailsCard id={id} card callBack={setPerson} />
        </Col>
        {person && (
          <Col xxl={8} xl={7}>
            <Card>
              <Tab.Container
                defaultActiveKey={person.company ? "company" : "notes"}
              >
                <SimpleBar>
                  <Card.Header className="p-0 border-bottom">
                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                      {person.company && (
                        <Nav.Item>
                          <Nav.Link
                            eventKey="company"
                            className="d-flex align-items-center py-3 px-x1 mb-0"
                          >
                            <FontAwesomeIcon
                              icon={faUser}
                              className="text-600 tab-icon"
                            />
                            <h6 className="text-600 mb-0 ms-1">Entreprise</h6>
                          </Nav.Link>
                        </Nav.Item>
                      )}
                      <Nav.Item>
                        <Nav.Link
                          eventKey="courses"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faUsers}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Formation", totals.courses)}
                            &nbsp;(
                            {totals.courses})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="notes"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faComment}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Note", totals.notes)}&nbsp;(
                            {totals.notes})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="calls"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faPhone}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Appel", totals.calls)}&nbsp;(
                            {totals.calls})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>
                </SimpleBar>
                <Card.Body className="bg-light">
                  <Tab.Content>
                    <Tab.Pane eventKey="notes">
                      <PersonNotesCard
                        id={id}
                        onGetTotal={(total) => onGetTotal("notes", total)}
                      />
                    </Tab.Pane>
                    <Tab.Pane eventKey="calls">
                      <RecordCallLogsCard
                        personId={id}
                        onGetTotal={(total) => onGetTotal("calls", total)}
                      />
                    </Tab.Pane>
                  </Tab.Content>
                </Card.Body>
              </Tab.Container>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default PersonView;
